module.exports = __webpack_public_path__ + "static/BTP_review-646c03c2a9a903cdfd4493292881b06a.png";